import axios from 'axios'


// Option lists for the edit windows (`api/variables/get_variables/`): the curated lists in
// operation/custom_variables.py plus the values each free-text field actually holds.
// Fetched once and shared by every window.
let options_request=null

export function load_options(){
    if(!options_request){
        options_request=axios.post('/variables/get_variables/')
            .then(response=>response.data)
            .catch(()=>{
                options_request=null    // try again the next time a window opens
                return {curated:{},observed:{}}
            })
    }
    return options_request
}


export function full_name(user){
    if(!user){
        return ''
    }
    return [user.first_name,user.last_name].filter(Boolean).join(' ') || user.username
}


// Only real web addresses get an "Open" link; anything else is just text.
export function web_link(value){
    return /^https?:\/\//i.test(value || '') ? value : null
}
